import { FCoworkingOfferType } from '../../../../utils/category';

export const coworkingOfferTypeNames = {
  [FCoworkingOfferType.FlexibleOffice]: 'Отдел. офис',
  [FCoworkingOfferType.FixedWorkSpace]: 'Закреп. место',
  [FCoworkingOfferType.FreeWorkSpace]: 'Незакреп. место',
};
